const ApiConfigs = {
    // CORE_API_URL : "http://localhost:3002",
    CORE_API_URL : "https://api.a-ztek225.com/",
}

export default ApiConfigs